export const boardPortalUrl = process.env.REACT_APP_ON_BOARD_PORTAL_URL;
